<template>
  <div class="material">
    <div class="header-tool" style="min-height: 100px;">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem>展会管理</BreadcrumbItem>
          <BreadcrumbItem to="/host/index/audit/list">展商审核</BreadcrumbItem>
          <BreadcrumbItem>展商审核详情</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title" v-if="query">{{query.name}}</div>
      </div>
    </div>
    <div class="header-tabs">
      <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
        <TabPane label="公司信息" name="1" v-if="arr.indexOf(1) !== -1">
          <hostAuditInfoCompany v-if="showTabs === '1'"></hostAuditInfoCompany>
        </TabPane>
        <TabPane label="联系人信息" name="2" v-if="arr.indexOf(2) !== -1">
          <hostAuditInfoContact v-if="showTabs === '2'"></hostAuditInfoContact>
        </TabPane>
        <TabPane label="会刊信息" name="3" v-if="arr.indexOf(3) !== -1">
          <hostAuditInfoPeriodical v-if="showTabs === '3'"></hostAuditInfoPeriodical>
        </TabPane>
        <TabPane label="开票信息" name="4" v-if="arr.indexOf(4) !== -1">
          <hostAuditInfoInvoice v-if="showTabs === '4'"></hostAuditInfoInvoice>
        </TabPane>
        <TabPane label="楣板信息" name="5" v-if="arr.indexOf(5) !== -1">
          <hostAuditInfoLintel v-if="showTabs === '5'"></hostAuditInfoLintel>
        </TabPane>
        <!-- <TabPane label="订单信息" name="6" v-if="arr.indexOf(6) !== -1">
          <hostAuditInfoOrder v-if="showTabs === '6'"></hostAuditInfoOrder>
        </TabPane> -->
        <TabPane label="车证信息" name="7" v-if="isHas">
          <hostAuditInfoCar v-if="showTabs === '7'"></hostAuditInfoCar>
        </TabPane>
      </Tabs>
    </div>
  </div>
</template>

<script>
import hostAuditInfoCompany from "./subpages/host-audit-info-company";
import hostAuditInfoInvoice from "./subpages/host-audit-info-invoice";
import hostAuditInfoPeriodical from "./subpages/host-audit-info-periodical";
import hostAuditInfoContact from "./subpages/host-audit-info-contact";
import hostAuditInfoLintel from "./subpages/host-audit-info-lintel";
import hostAuditInfoCar from "./subpages/host-audit-info-car";
// import hostAuditInfoOrder from "./subpages/host-audit-info-order";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "host-audit-info",
  data() {
    return {
      showTabs: "1",
      query: null,
      arr: [],
      isHas: true
    };
  },
  components: {
    hostAuditInfoCompany,
    hostAuditInfoInvoice,
    hostAuditInfoPeriodical,
    hostAuditInfoContact,
    hostAuditInfoLintel,
    hostAuditInfoCar,
    // hostAuditInfoOrder,
  },
  computed: {
    ...mapGetters({
      exhibitionInfo: "hostSetModule/getHostExhibition"
    })
  },
  created() {
    this.query = this.$route.query;
    this.changeTab();
    this.init();
  },
  methods: {
    ...mapActions({
      getHasAuditInfos: "hostAuditModule/getHasAuditInfos",
      getIsCar: "hostAuditModule/getIsCar",
    }),
    async init() {
      this.arr = await this.getHasAuditInfos(this.$route.query.id);
      if (this.arr.length) {
        this.showTabs = this.arr[0] + "";
      }
      let info = await this.getIsCar(this.$route.query.id);
      if (info && info.isHas) {
        this.isHas = true;
      } else {
        this.isHas = false;
      }
    },
    changeTab() {
      const query = this.$route.query;
      if (query && query.type) {
        this.showTabs = query.type;
      }
    },
    switchBrand(name) {
      const query = this.$route.query;
      this.$router.push(
        `${this.$route.path}?id=${query.id}&type=${name}&name=${query.name}`
      );
    }
  }
};
</script>

<style scoped lang="scss">
.header-tool-utils {
  margin-top: 20px;
  button {
    margin-right: 20px;
  }
}
</style>

